import type { RouterConfig } from '@nuxt/schema';
import type {
    RouteLocation,
    RouteRecordRaw,
    RouteRecordRedirect,
} from 'vue-router';

export default <RouterConfig>{
    routes: (_routes: Readonly<RouteRecordRaw[]>) => {
        return [
            ..._routes,
            {
                name: 'members.index',
                path: '/members',
                redirect: (_: RouteLocation) => {
                    // the function receives the target route as the argument
                    // we return a redirect path/location here.
                    return { path: '/members/dashboard' };
                },
            } as RouteRecordRedirect,
            {
                name: 'admin.index',
                path: '/admin',
                redirect: (_: RouteLocation) => {
                    // TODO - implement redirect logic
                    return { path: '/' };
                },
            },
            {
                name: 'admin.team.index',
                path: '/admin/{team}',
                redirect: (_: RouteLocation) => {
                    // TODO - implement redirect logic
                    return { path: '/' };
                },
            },
            {
                name: 'members.login',
                path: '/members/login',
                redirect: (_: RouteLocation) => {
                    // TODO - implement redirect logic
                    return { path: '/' };
                },
            },
            {
                name: 'admin.login',
                path: '/admin/login',
                redirect: (_: RouteLocation) => {
                    // TODO - implement redirect logic
                    return { path: '/' };
                },
            },
        ];
    },
};
